import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useLogout from '../../../auth/logout';
import { useUserInfo } from '../../../auth/use_user_info';
import linkIcon from '../../../assets/icon128.png';
import './AppHeader.css';

function AppHeader() {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const logout = useLogout();
  const navigate = useNavigate();
  const { user, isLoading, userName, userInitial, userAvatar } = useUserInfo();

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleAvatarClick = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = () => {
    setShowMenu(false);
    logout();
  };

  const handleAdministration = () => {
    setShowMenu(false);
    navigate('/administration');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <img 
          alt="Liminal" 
          src={linkIcon} 
          className="header-logo" 
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        <span className="header-title">Liminal Link</span>
      </div>
      
      <div className="header-right">
        {user && (
          <div className="user-info">
            <span className="user-name">
              {userName}
            </span>
          </div>
        )}
        <div className="avatar-container" ref={menuRef}>
          <div className="avatar" onClick={handleAvatarClick}>
            <div className="avatar-image">
              {userAvatar ? (
                <img src={userAvatar} alt="User avatar" className="avatar-img" />
              ) : (
                <span className="avatar-initial">
                  {userInitial}
                </span>
              )}
            </div>
          </div>
          
          {showMenu && (
            <div className="avatar-menu">
              {user?.role === 'admin' && (
                <button onClick={handleAdministration} className="menu-button">
                  <i className="ti ti-settings"></i>
                  Administration
                </button>
              )}
              <button onClick={handleLogout} className="logout-button">
                <i className="ti ti-logout"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default AppHeader; 